import React from 'react';
import {
  Card,
  Grid,
  Table,
  Icon,
  Popup,
  Modal,
  Image,
  Header,
  Button,
} from 'semantic-ui-react';
import numeral from 'numeral';
import _ from 'lodash';

import { Doughnut } from 'react-chartjs-2';

const colorMap = {
  instagram: 'pink',
  twitter: 'blue',
  snapchat: 'yellow',
};

const cf = (num) => num ? numeral(num).format('0,0') : '-';

const imageWrapperStyle = {
  maxHeight: 500,
  overflowY: 'scroll',
};

const ReportSupportingActivity = ({ posts, supportingData, info }) => (
  <Card fluid color="green">
  <Card.Content>
    <Card.Header>
      Supporting activity
    </Card.Header>
    <Card.Meta>
      { info.influencerName }&apos;s posts on other social networks
    </Card.Meta>
  </Card.Content>
  <Card.Content>
  <Grid>
    <Grid.Row>
      <Grid.Column computer={supportingData ? 10 : 16} mobile={16}>
        <Table celled fluid size="small" basic="very" singleLine textAlign="center">
           <Table.Header>
             <Table.Row>
               <Table.HeaderCell collapsing>channel</Table.HeaderCell>
               <Table.HeaderCell>description</Table.HeaderCell>
               <Table.HeaderCell>impressions/views</Table.HeaderCell>
               <Table.HeaderCell>engagements</Table.HeaderCell>
               <Table.HeaderCell>
                <Popup
                  trigger={<span>#ad?</span>}
                  content="Has the post been marked as an advert or sponsored post?"
                />
               </Table.HeaderCell>
               <Table.HeaderCell>
               <Popup
                 trigger={<span>screenshot</span>}
                 content="supporting screenshot"
               />
               </Table.HeaderCell>
             </Table.Row>
           </Table.Header>
           <Table.Body>
            {
              _.map(posts, post => (
                <Table.Row>
                  <Table.Cell textAlign="center"><Icon name={post.platform} size="large" color={ colorMap[post.platform] }/></Table.Cell>
                  <Table.Cell textAlign="left">

                    {
                      !supportingData &&
                      <Image src={post.screenshot} size="mini" floated="left" />
                    }
                    {
                      post.url
                      ? <a href={post.url} target="_blank">{ _.truncate(post.title, {length:40}) }</a>
                      : _.truncate(post.title, {length:40})
                    }
                  </Table.Cell>
                  <Table.Cell textAlign="center">{ cf(post.views || post.impressions) }</Table.Cell>
                  <Table.Cell textAlign="center">{ cf(post.engagements) }</Table.Cell>
                  <Table.Cell textAlign="center">
                    <Icon name="check" color="green" />
                  </Table.Cell>
                  <Table.Cell textAlign="center">
                    <Modal trigger={<Button icon="file image outline" circular basic color="pink" />} size='small'>
                      <Header icon='file image outline' content='Supporting screenshot' />
                      <Modal.Content>
                        <div style={imageWrapperStyle}>
                          <Image src={post.screenshot} size="large" bordered centered />
                        </div>
                        <h4>Extracted Data</h4>
                        <Table celled fluid size="small" basic="very">
                          <Table.Body>
                          <Table.Row>
                            <Table.Cell>
                              reach
                            </Table.Cell>
                            <Table.Cell>
                              { cf(post.reach) }
                            </Table.Cell>
                          </Table.Row>
                            <Table.Row>
                              <Table.Cell>
                                impressions/views
                              </Table.Cell>
                              <Table.Cell>
                                { cf(post.views || post.impressions) }
                              </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                              <Table.Cell>
                                engagements
                              </Table.Cell>
                              <Table.Cell>
                                { cf(post.engagements) }
                              </Table.Cell>
                            </Table.Row>
                          </Table.Body>
                        </Table>
                      </Modal.Content>
                      <Modal.Actions style={{textAlign:"center"}}>
                        <h4>press ESCAPE to close</h4>
                      </Modal.Actions>
                    </Modal>
                  </Table.Cell>
                </Table.Row>
              ))
            }
            <Table.Row>
              <Table.Cell collapsing></Table.Cell>
              <Table.Cell><h4>TOTALS</h4></Table.Cell>
              <Table.Cell textAlign="center"><h4>{ cf(_.reduce(posts, (sum, n) => (sum + ((n.views || n.impressions) || 0)), 0)) }</h4></Table.Cell>
              <Table.Cell textAlign="center"><h4>{ cf(_.reduce(posts, (sum, n) => (sum + (n.engagements || 0)), 0)) }</h4></Table.Cell>
              <Table.Cell />
              <Table.Cell />
            </Table.Row>

           </Table.Body>
         </Table>
         <p>&nbsp;</p>
       </Grid.Column>
       <Grid.Column computer={supportingData ? 6 : 0} mobile={16}>

       { supportingData &&
         <div>
        <h4 style={{paddingLeft: '40px', marginTop: 0}}>Impressions by channel</h4>
         <Doughnut data={supportingData} />

         {
           info.campaignArchive &&
           <div style={{ margin: 50 }}>
            <h4>download all supporting screenshots here!</h4>
            <Button fluid massive content="Download Files" icon="download" color="pink" onClick={() => {
              window.open(info.campaignArchive, '_blank');
            }} />
           </div>
         }

         </div>
       }
       </Grid.Column>
       </Grid.Row>
     </Grid>
   </Card.Content>

   <Card.Content extra>
     <p>twitter engagements are calculated as retweets + link clicks + follows + likes</p>
     <p>instagram engagements are calculated as likes + comments + saves</p>
   </Card.Content>
  </Card>
)

export default ReportSupportingActivity;



// WEBPACK FOOTER //
// ./src/components/report-supporting-activity/index.js